import { VirtualCursorList } from '../../ui-kit/VirtualCursorList'
import type { WindowedCursorListRange } from '../../../hooks/useWindowedCursorList'
import { ProjectItem } from '../ProjectItem'
import type { TProjectsListResponse } from '../../../api/types'

type ProjectsListProps = {
  projects: TProjectsListResponse
  firstItemIndex?: number
  hasMore?: boolean
  isLoadingMore?: boolean
  onLoadMore?: () => void
  onStartReached?: () => void
  onRangeChanged?: (range: WindowedCursorListRange) => void
}

export const ProjectsList = ({
  projects,
  firstItemIndex,
  hasMore,
  isLoadingMore,
  onLoadMore,
  onStartReached,
  onRangeChanged,
}: ProjectsListProps) => {
  return (
    <VirtualCursorList
      items={projects}
      firstItemIndex={firstItemIndex}
      hasMore={hasMore}
      isLoadingMore={isLoadingMore}
      onLoadMore={onLoadMore}
      onStartReached={onStartReached}
      onRangeChanged={onRangeChanged}
      getItemKey={(_index, project) => project.id}
      emptyMessage="Нет проектов для отображения"
      itemContent={(_index, project) => <ProjectItem project={project} />}
    />
  )
}
